export default "__VITE_ASSET__DRRZ8v$O__"